import Button from '@berlitz/button'
import Link from 'next/link'
import { Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

import { GroupLabel } from '@components/Radio/style'

export const StyledPCol = styled(Col)`
  margin-bottom: ${({ theme }) => theme.space.md};
`

export const StyledCol = styled(Col)`
  padding-left: 0;
  padding-right: ${({ theme }) => theme.space.xs};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding-right: 0;
  }
`

export const FileContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  float: left;
  width: 100%;
  padding: ${({ theme }) => theme.space.xxxs};
  margin-right: ${({ theme }) => theme.space.xxs};
  margin-bottom: ${({ theme }) => theme.space.xxs};
`

export const Info = styled.div`
  color: ${({ theme }) => theme.palette.charcoal};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  margin-left: ${({ theme }) => theme.space.xs};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
`

export const Label = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`

export const P = styled.p`
  a {
    display: inline-block;
    cursor: pointer;
    text-decoration: underline;
    vertical-align: top;
    color: ${({ theme }) => theme.palette.blue100};
  }

  &:first-of-type {
    margin: 0;
  }
`

export const StyledButton = styled(Button)`
  border: 2px solid ${({ theme }) => theme.colors.brandPrimary};
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  text-decoration: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    justify-content: center;
  }
`

export const MediaCol = styled(Col)`
  margin-bottom: ${({ theme }) => theme.space.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${({ theme }) => theme.space.sm};
  }
`

export const MediaP = styled.p`
  font-size: ${({ theme }) => theme.fontSize.xxxs}
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.space.xs};
`

export const StyledRow = styled.div`
  margin-bottom: ${({ theme }) => theme.space.sm};
`

export const RadioContainer = styled.div`
  ${GroupLabel} {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  a {
    text-decoration: none;
  }
`

export const NoPaddingCol = styled(Col)`
  padding-left: 0;
  padding-right: 0;
`
